export default "__VITE_ASSET__GWVRTlhc__"